<script setup>
import QuestionStatistics from '@/components/PollTemplate/Components/QuestionStatistics.vue'

const props = defineProps(['questionGroup', 'statistics', 'workflow', 'workflows'])

</script>

<template>
  <div class="qg-statistics">
    <question-statistics
            v-for="(question) in questionGroup['questions']"
            :key="question.id"
            :statistics="statistics"
            :currentQuestion="question"
            :workflow="workflow"
            :workflows="workflows"
    >
    </question-statistics>
  </div>
</template>
